export default Object.freeze({
    CREATED_AT_ASC: {
        label: 'CREATED_AT_ASC',
        value: {
            orderBy: 'createdAt',
            wayDefinition: 'ASC',
        },
    },
    CREATED_AT_DESC: {
        label: 'CREATED_AT_DESC',
        value: {
            orderBy: 'createdAt',
            wayDefinition: 'DESC',
        },
    },
    FIRST_NAME_ASC: {
        label: 'FIRST_NAME_ASC',
        value: {
            orderBy: 'firstName',
            wayDefinition: 'ASC',
        },
    },
    FIRST_NAME_DESC: {
        label: 'FIRST_NAME_DESC',
        value: {
            orderBy: 'firstName',
            wayDefinition: 'DESC',
        },
    },
    LAST_NAME_ASC: {
        label: 'LAST_NAME_ASC',
        value: {
            orderBy: 'lastName',
            wayDefinition: 'ASC',
        },
    },
    LAST_NAME_DESC: {
        label: 'LAST_NAME_DESC',
        value: {
            orderBy: 'lastName',
            wayDefinition: 'DESC',
        },
    },
    RESERVATION_TIME_ASC: {
        label: 'RESERVATION_TIME_ASC',
        value: {
            orderBy: 'reservationTime',
            wayDefinition: 'ASC',
        },
    },
    RESERVATION_TIME_DESC: {
        label: 'RESERVATION_TIME_DESC',
        value: {
            orderBy: 'reservationTime',
            wayDefinition: 'DESC',
        },
    },
})
